// extracted by mini-css-extract-plugin
module.exports = {"positionedField":"PositionedField_positionedField__25cNU"};